import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import trustpilot from '../../../assets/images/trustpilot.svg';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { useParams } from 'react-router-dom';

import api from 'utils/api';

const PREFIX = 'ThumbUpFeedbackCompose';

const classes = {
  title: `${PREFIX}-title`,
  text: `${PREFIX}-text`,
  logo: `${PREFIX}-logo`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.title}`]: {
    fontWeight: 'bold',
    color: theme.colorTokens.onSurfaceTextHeadline,
  },

  [`& .${classes.text}`]: {
    marginTop: 15,
    textAlign: 'center',
    color: theme.colorTokens.onSurfaceTextTitle,
  },

  [`& .${classes.logo}`]: {
    width: '110px',
  },
}));

const trustpilotReviewUrl = 'https://www.trustpilot.com/evaluate/gojitsu.com';

function ThumbUpFeedback({ thumbValue, store }) {
  const { tracking_code } = useParams();

  const isValidConfig = import.meta.env.REACT_APP_THUMBUP_FEEDBACK_WIDGET && import.meta.env.REACT_APP_THUMBUP_FEEDBACK_DATA_URL;

  const injectWidget = () => {
    if (!import.meta.env.REACT_APP_THUMBUP_FEEDBACK_WIDGET) return;

    const script = document.createElement('script');
    script.src = import.meta.env.REACT_APP_THUMBUP_FEEDBACK_WIDGET;

    document.body.appendChild(script);
  };

  useEffect(() => {
    injectWidget();
    store.deliveryStore.updateField('isSubmittedFeedback', false);
    if (store.podStore.isPODFeedback) {
      store.deliveryStore.updateField('lastStep', true);
    }
    api.get(`delivery/${tracking_code}`).then((res) => store.deliveryStore.updateField('delivery', res.data));

    return () => {
      const scripts = document.getElementsByTagName('script');

      for (let script of scripts) {
        if (script.src.includes('reviewmgr')) script.remove();
      }
    };
  }, []);

  return (
    <Root>
      {thumbValue && isValidConfig ? (
        <div className="reviewmgr-embed" data-url={import.meta.env.REACT_APP_THUMBUP_FEEDBACK_DATA_URL}></div>
      ) : (
        <>
          <Typography variant="h6" align="center" className={classes.title}>
            Thank you for your feedback!
          </Typography>
          {thumbValue ? (
            <>
              <Typography className={classes.text}>We invite you to leave an external review for us. Please click below!</Typography>
              <div className={classes.text}>
                <a href={trustpilotReviewUrl} target="_blank" rel="noopener noreferrer">
                  <img className={classes.logo} src={trustpilot} alt="Trust Pilot" />
                </a>
              </div>
            </>
          ) : (
            <div className={classes.text}>We appreciate your feedback to help us improve!</div>
          )}
        </>
      )}
    </Root>
  );
}

const ThumbUpFeedbackCompose = compose(inject('store'), observer)(ThumbUpFeedback);

export default ThumbUpFeedbackCompose;
